<template>
  <pages-editions-slug-education-component
    :data="data"
    v-if="data"
  />
  <shared-error-component v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
defineRouteRules({
  robots: false,
})

const route = useRoute()

const props = defineProps({
  biennialEntryId: {
    type: Number,
    required: false
  }
})

const { data, error } = await useAsyncData(() => $fetch('/api/strapi-rest', { query: { path: queryEducationPageCategoriesByBiennialSlug(getPageQuery()) } } ) )

data.value = data.value?.data
</script>
